import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { OrchestratorCardsList } from '@domains/orchestrator-pricing-committee';
import { useCurrentOrchestrator } from '@domains/orchestrator-pricing-committee/hooks/useCurrentOrchestrator';
import { pathOPCDashboard } from '../../routes/routes.types';
import { OrchestratorPricingCommitteeLayout } from '@pages/OrchestratorPricingCommitteePage/shared/OrchestratorPricingCommitteeLayout/OrchestratorPricingCommitteeLayout';

export const OrchestratorList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { rawNid } = useCurrentOrchestrator();

  useEffect(() => {
    if (
      rawNid &&
      location.pathname !==
        `/orchestrator-pricing-committee/${pathOPCDashboard}`
    ) {
      navigate(`/orchestrator-pricing-committee/${pathOPCDashboard}`);
    }
  }, [rawNid, location.pathname, navigate]);

  return (
    <OrchestratorPricingCommitteeLayout title="La Central">
      <OrchestratorCardsList />
    </OrchestratorPricingCommitteeLayout>
  );
};
